<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
   <div class="mb3 text-left">
         <span class="no_permohonan">{{data.no_permohonan}}</span> | <w-tag class="mr4" bg-color="primary" round> {{data.status_keterangan}} </w-tag>
   </div>
    <z-page title="Senarai Pilih Ternakan">
<!-- jantan -->
      <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI PILIH TERNAKAN JANTAN'">
        <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
          <!-- <w-form ref="form_bse" v-model="form_bse.valid" @validate="validateFormJantan" @success="success"> -->
          <template #title>
            SENARAI PILIH TERNAKAN
          </template>
          <div class="w-table-wrap" style="max-height: 400px;">
            <div class="table-profil-scrol">
              <table class="w-table" color="light">
                <thead>
                  <tr>
                    <th class="w-table__header text-center" width="1%">BIL</th>
                    <th class="w-table__header text-center">NO PENDAFTARAN</th>
                    <th class="w-table__header text-center">ID | NAMA TERNAKAN</th>
                    <th class="w-table__header text-center">ID INDUK</th>
                    <th class="w-table__header text-center">BAKA</th>
                    <th class="w-table__header text-center">JANTINA</th>
                    <th class="w-table__header text-center">TARIKH LAHIR</th>
                    <th class="w-table__header text-center">(UMUR BULAN)</th>
                    <th class="w-table__header text-center">TARIKH AKHIR PEMERIKSAAN BSE</th>
                    <th class="w-table__header text-center">TINDAKAN</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <template v-for="(dt, ind) in data.ternakan_list" :key="dt.id"> -->
                  <template v-for="(dt, ind) in data.ternakan_list.filter(t => t.jantina_id == 1)" :key="dt.id">
                    <tr class="w-table__row">
                      <td class="w-table__cell text-center">{{ind+1}}</td>
                      <td class="w-table__cell text-center">{{dt.no_pendaftaran}}</td>
                      <td class="w-table__cell text-center">{{dt.ternakan_nama}}</td>
                      <td class="w-table__cell text-center">{{dt.id_bapa}}</td>
                      <td class="w-table__cell text-center">{{dt.lkp_baka}}</td>
                      <td class="w-table__cell text-center">{{dt.jantina}}</td>
                      <td class="w-table__cell text-center">{{$zutil.dateformat(dt.tarikh_lahir)}}</td>
                      <td class="w-table__cell text-center">{{$zutil.umurBln(dt.tarikh_lahir)}}</td>
                      <td class="w-table__cell text-center">
                        <template v-if="dt.art_pdbf != null"> 
                           {{$zutil.dateformat(dt.art_pdbf ? dt.art_pdbf.tarikh_pdbf : '' )}} 
                           <w-tag
                              class="mr4"
                              bg-color="primary">
                              {{dt.art_pdbf ? dt.art_pdbf.art_status_nama : ''}}
                           </w-tag>
                        </template>
                        <template v-else>
                           -
                        </template>
                          

                      </td>
                      <td class="w-table__cell text-center">
                        <template v-if="dt.art_pdbf != null">
                           <template v-if="dt.art_pdbf.tarikh_pdbf < dt.tarikh_batas">
                              <w-checkbox v-model="dt.pilih_jantan" @input="klickPiJantan(dt)"></w-checkbox>
                           </template>
                           <template v-else>
                              <w-tooltip md top color="white" bg-color="black" >
                                    <template #activator="{ on }">
                                       <w-button  bg-color="warning" v-on="on" v-if="$zutil.anyRole(['4']) && dt.jantina_id == 1 && dt.art_pdbf.art_status != 18" :route="$route('art.semakan.bse',dt.art_pdbf.id_art)" class="be fs-2"><div style="width: 8px"></div>
                                          <w-icon md class="mr2">fal fa-pencil</w-icon>
                                       </w-button>
                                    </template>
                                  Kemaskini BSE
                                 </w-tooltip>
                           </template>
                        </template>
                        <template v-else>
                           <w-checkbox v-model="dt.pilih_jantan" @input="klickPiJantan(dt)"></w-checkbox>
                        </template>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
          
          <div class="mt2 text-right" v-if="showMohonBseButton">
            <!-- <w-button bg-color="success" @click="daftarBse" class="be fs-2" :loading="loading">
              <w-icon xs class="mr2">fal fa-check</w-icon> Mohon BSE
            </w-button>&nbsp; -->
            <w-button bg-color="success" @click="add(data, 1)" class="be fs-2" :loading="loading">
              <w-icon xs class="mr2">fal fa-check</w-icon> Mohon BSE
            </w-button>&nbsp;
          </div>
        </w-form>
      </w-card>
      <br>

<!-- Betina -->

       <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI PILIH TERNAKAN BETINA'">
        <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
          <!-- <w-form ref="form_bse" v-model="form_bse.valid" @validate="validateFormJantan" @success="success"> -->
          <template #title>
            SENARAI PILIH TERNAKAN
          </template>
          <div class="w-table-wrap" style="max-height: 400px;">
            <div class="table-profil-scrol">
              <table class="w-table" color="light">
                <thead>
                  <tr>
                    <th class="w-table__header text-center" width="1%">BIL</th>
                    <th class="w-table__header text-center">NO PENDAFTARAN</th>
                    <th class="w-table__header text-center">ID | NAMA TERNAKAN</th>
                    <th class="w-table__header text-center">ID INDUK</th>
                    <th class="w-table__header text-center">BAKA</th>
                    <th class="w-table__header text-center">JANTINA</th>
                    <th class="w-table__header text-center">TARIKH LAHIR</th>
                    <th class="w-table__header text-center">(UMUR BULAN)</th>
                    <th class="w-table__header text-center">TARIKH AKHIR PEMERIKSAAN FE</th>
                    <th class="w-table__header text-center">TINDAKAN</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <template v-for="(dt, ind) in data.ternakan_list" :key="dt.id"> -->
                  <template v-for="(dt, ind) in data.ternakan_list.filter(t => t.jantina_id == 2)" :key="dt.id">
                    <tr class="w-table__row">
                      <td class="w-table__cell text-center">{{ind+1}}</td>
                      <td class="w-table__cell text-center">{{dt.no_pendaftaran}}</td>
                      <td class="w-table__cell text-center">{{dt.ternakan_nama}}</td>
                      <td class="w-table__cell text-center">{{dt.id_bapa}}</td>
                      <td class="w-table__cell text-center">{{dt.lkp_baka}}</td>
                      <td class="w-table__cell text-center">{{dt.jantina}}</td>
                      <td class="w-table__cell text-center">{{$zutil.dateformat(dt.tarikh_lahir)}}</td>
                      <td class="w-table__cell text-center">{{$zutil.umurBln(dt.tarikh_lahir)}}</td>
                      <td class="w-table__cell text-center">
                        <template v-if="dt.art_pdbf != null"> 
                           {{$zutil.dateformat(dt.art_pdbf ? dt.art_pdbf.tarikh_pdbf : '' )}} 
                           <w-tag
                              class="mr4"
                              bg-color="primary">
                              {{dt.art_pdbf ? dt.art_pdbf.art_status_nama : ''}}
                           </w-tag>
                        </template>
                        <template v-else>
                           -
                        </template>
                          

                      </td>
                      <td class="w-table__cell text-center">
                        <template v-if="dt.art_pdbf != null">
                           <template v-if="dt.art_pdbf.tarikh_pdbf < dt.tarikh_batas">
                              <w-checkbox v-model="dt.pilih_betina" @input="klickPiBetina(dt)"></w-checkbox>
                           </template>
                           <template v-else>
                              <w-tooltip md top color="white" bg-color="black" >
                                    <template #activator="{ on }">
                                       <w-button  bg-color="warning" v-on="on" v-if="$zutil.anyRole(['4']) && dt.jantina_id == 2 && dt.art_pdbf.art_status != 18" :route="$route('art.semakan.fe',dt.art_pdbf.id_art)" class="be fs-2"><div style="width: 8px"></div>
                                          <w-icon md class="mr2">fal fa-pencil</w-icon>
                                       </w-button>

                                    </template>
                                  Kemaskini FE
                                 </w-tooltip>
                           </template>
                        </template>
                        <template v-else>
                           <w-checkbox v-model="dt.pilih_betina" @input="klickPiBetina(dt)"></w-checkbox>
                        </template>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
          
          <div class="mt2 text-right" v-if="showMohonFeButton">
            <!-- <w-button bg-color="success" @click="daftarBse" class="be fs-2" :loading="loading">
              <w-icon xs class="mr2">fal fa-check</w-icon> Mohon BSE
            </w-button>&nbsp; -->
            <w-button bg-color="success" @click="addBetina(data, 1)" class="be fs-2" :loading="loading">
              <w-icon xs class="mr2">fal fa-check</w-icon> Mohon FE
            </w-button>&nbsp;
          </div>
        </w-form>
      </w-card>
      <br>
    

       <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['4']) && this.data.lkp_status_id == 44">  
             <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
               <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
            </w-button>
      </w-flex>
      <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup()">TUTUP</w-button>&nbsp;
      </div>
    </z-page>

         <w-dialog
            v-model="dialogPenilaian.show"
            :fullscreen="dialogPenilaian.fullscreen"
            width="700"
            :persistent="dialogPenilaian.persistent"
            :persistent-no-animation="dialogPenilaian.persistentNoAnimation"
            title-class="primary-dark1--bg white">
               <template #title>
                 Tarikh Temu Janji Penilaian BSE
               </template>
                    

            <w-form ref="form_bse" v-model="dialogPenilaian.valid" @validate="validateFormJantan" @success="success">
                  <div class="w-flex wrap smd-column" >
                  <div class="grow " >
                     <w-input class="mt4" outline label="Tarikh Temu Janji Penilaian *" type="date" v-model="form_bse.tarikh_temujanji" :validators="[validators.required]"/>
                      <w-select class="mt4" outline :items="penilai" label="Nama Pegawai Penilaian *"  v-model="form_bse.penilai_id" multiple :validators="[validators.required]"/>
                  </div>
               </div>
            </w-form>

             <template #actions>
            <div class="spacer" />
               <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogPenilaian.show = false">TUTUP</w-button>
              
               <!-- <w-button class="my1" @click="daftarBse()" ><div style="width: 6px"></div> 
                                          <w-icon class="mr1" md >fal fa-paper-plane</w-icon>
                                    </w-button> -->

                <w-button class="ml1" :loading="dialogPenilaian.loading" @click="$refs.form_bse.validate()">
                  <w-icon class="mr1" md >fal fa-paper-plane</w-icon>Hantar
                </w-button>

               <!-- <w-button class="ml1" :loading="dialogPenilaian.loading" @click="$refs.form.validate()">SIMPAN</w-button> -->
            </template>
         </w-dialog>



         <w-dialog
            v-model="dialogPenilaianBetina.show"
            :fullscreen="dialogPenilaianBetina.fullscreen"
            width="700"
            :persistent="dialogPenilaianBetina.persistent"
            :persistent-no-animation="dialogPenilaianBetina.persistentNoAnimation"
            title-class="primary-dark1--bg white">
               <template #title>
                 Tarikh Temu Janji Penilaian FE
               </template>
                    

            <w-form ref="form_fe" v-model="dialogPenilaianBetina.valid" @validate="validateFormBetina" @success="success">
                  <div class="w-flex wrap smd-column" >
                  <div class="grow " >
                     <w-input class="mt4" outline label="Tarikh Temu Janji Penilaian *" type="date" v-model="form_fe.tarikh_temujanji" :validators="[validators.required]"/>
                      <w-select class="mt4" outline :items="penilai" label="Nama Pegawai Penilaian *"  v-model="form_fe.penilai_id" multiple :validators="[validators.required]"/>
                  </div>
               </div>
            </w-form>

             <template #actions>
            <div class="spacer" />
               <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogPenilaianBetina.show = false">TUTUP</w-button>
              
               <!-- <w-button class="my1" @click="daftarBse()" ><div style="width: 6px"></div> 
                                          <w-icon class="mr1" md >fal fa-paper-plane</w-icon>
                                    </w-button> -->

                <w-button class="ml1" :loading="dialogPenilaianBetina.loading" @click="$refs.form_fe.validate()">
                  <w-icon class="mr1" md >fal fa-paper-plane</w-icon>Hantar
                </w-button>

               <!-- <w-button class="ml1" :loading="dialogPenilaian.loading" @click="$refs.form.validate()">SIMPAN</w-button> -->
            </template>
         </w-dialog>

  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      resourceurl: this.api_service + "baka",
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Baka', route: '/kelahiran' },
        { label: 'Permohonan', route: '/kelahiran/permohonan' },
        { label: 'Show', route: '/kelahiran/permohonan/'+this.id },
      ],
      data: {id: 0, ternakan_list: []},
      attahecment: [],
      slides: [],
      activeTab: 0,
      tabs: [
        { title: 'Lokasi', content: '' }
      ],
      penilai:[],
      dialogPenilaian: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
          width: 1800,
        item: {}
      },
      dialogPenilaianBetina: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
          width: 1800,
        item: {}
      },
      showMohonFeButton: false,
      showMohonBseButton: false,
      loading: false,
      form: {
        baka_id: this.id,
        // ternakan_list: [],
        // hantar: 1
      }
    }
  },
  methods: {

    add(item, tindakan){
          this.form_bse = {
              // id : item.id,
              penilai_id : '',
              tarikh_temujanji : '',
              tindakan : tindakan,
              jantina_ind : 1,

          }
          
          this.getPenilai(item)
          this.dialogPenilaian.show = true
          this.dialogPenilaian.title = 'Tarikh Temu Janji Penilaian BSE'
          this.form.saveButton = "Simpan"
      },

      addBetina(item, tindakan){
          this.form_fe = {
              // id : item.id,
              penilai_id : '',
              tarikh_temujanji : '',
              tindakan : tindakan,
              jantina_ind : 2,

          }
          
          this.getPenilai(item)
          this.dialogPenilaianBetina.show = true
          this.dialogPenilaianBetina.title = 'Tarikh Temu Janji Penilaian FE'
          this.form.saveButton = "Simpan"
      },

    getData() {
      this.$zcomm.get(this.api_service + 'baka/show/'+this.id, {}).then(res => {
        this.data = res
        // Initialize pilih property for each ternakan if not exists
        if (this.data.ternakan_list) {
          this.data.ternakan_list.forEach(item => {
            if (item.pilih === undefined) {
              this.$set(item, 'pilih', false)
            }
          })
        }
        
        if(this.data.jantina != 1){
          this.tabs = [
            { title: 'Lokasi', content: '' },
            { title: 'Pemilik', content: '' },
            { title: 'Induk Jantan', content: '' },
            { title: 'Check-In Al Man', content: '' },
            { title: 'Penilaian Prestasi Anak', content: '' },
            { title: 'Inseminasi', content: '' },
            { title: 'Fertiliti Betina ', content: '' }
          ]
        }
        else {
          this.tabs = [
            { title: 'Lokasi', content: '' },
            { title: 'Pemilik', content: '' },
            { title: 'Induk Jantan', content: '' },
            { title: 'Check-In Al Man', content: '' },
            { title: 'Penilaian Prestasi Anak', content: '' },
            { title: 'Fertiliti Jantan', content: '' }
          ]
        }
        this.getAttahecment()
      })
    },

// <== Jantan ==>

    klickPiJantan(dt) {
      if (dt.pilih_jantan) {
        // Check if ternakan already applied in another application
        // this.$zcomm.get(this.api_service + 'check_ternakan/' + dt.ternakan_id)
        //   .then(res => {
        //     if (res.exists) {
        //       this.$zutil.notify("Ternakan ini telah dimohon sebelumnya!", false);
        //       dt.pilih_jantan = false; // Reset checkbox
        //     }
        //   });
      }
      
      // Update the showMohonBseButton based on whether any checkbox is checked
      this.showMohonBseButton = this.data.ternakan_list.some(item => item.pilih_jantan)
    },

    validateFormJantan() {
      this.loading = true;
      let isValid = true;
      let jumlah_lulus = 0;
      
      // Validate selected ternakan
      for (let i in this.data.ternakan_list) {
        if (this.data.ternakan_list[i].pilih_jantan) {
          jumlah_lulus++;
        }
      };
      if(!this.form_bse.penilai_id ||  !this.form_bse.tarikh_temujanji){
            isValid = false;
            this.$zutil.notify("Pastikan data sudah terisi", false);
            this.loading = false;
            return false;
      }
      
      if (jumlah_lulus === 0) {
        isValid = false;
        this.$zutil.notify("Sila pilih sekurang-kurangnya satu ternakan", false);
      }
      
      if (!isValid) {
        this.$zutil.notify("Pastikan data sudah terisi", false);
        this.loading = false;
        return false;
      }
      
      // Prepare data for submission
      this.form_bse.ternakan_list = this.data.ternakan_list.filter(item => item.pilih_jantan);
      this.HantarBse();
    },

    HantarBse() {
      
      this.form_bse.baka_id = this.data.id;
      this.form_bse.premis_id = this.data.premis_id;
      this.form_bse.lkp_negeri_id = this.data.lkp_negeri_id;
      this.form_bse.lkp_ternakan_id = this.data.lkp_ternakan_id;
      this.$swal({
        title: 'Anda Pasti?',
        text: "Adakah anda pasti ingin menghantar permohonan BSE ini?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, Hantar',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
            this.$zcomm.post(this.resourceurl + '/mohon-art', this.form_bse)
                  .then(res => {
                     this.$zutil.notify("Permohonan BSE berjaya dihantar", true);
                      // this.$inertia.visit(this.$route('art.semakan.index'));
                      // this.$inertia.visit(this.$route('art.semakan.bse', res.id));


                     this.dialogPenilaian.show = false;
                     this.getData();

                  })
                  .catch(error => {
                     this.$zutil.notify("Ralat ketika menghantar permohonan", false);
                     console.error(error);
                  })
                  .finally(() => {
                     this.loading = false;
                  });
           }
        });
    },



// <== Betina ==>

    klickPiBetina(dt) {
      if (dt.pilih_betina) {
      }
      
      // Update the showMohonBseButton based on whether any checkbox is checked
      this.showMohonFeButton = this.data.ternakan_list.some(item => item.pilih_betina)
    },

    validateFormBetina() {
      this.loading = true;
      let isValid = true;
      let jumlah_lulus = 0;
      
      // Validate selected ternakan
      for (let i in this.data.ternakan_list) {
        if (this.data.ternakan_list[i].pilih_betina) {
          jumlah_lulus++;
        }
      };
      if(!this.form_fe.penilai_id ||  !this.form_fe.tarikh_temujanji){
            isValid = false;
            this.$zutil.notify("Pastikan data sudah terisi", false);
            this.loading = false;
            return false;
      }
      
      if (jumlah_lulus === 0) {
        isValid = false;
        this.$zutil.notify("Sila pilih sekurang-kurangnya satu ternakan", false);
      }
      
      if (!isValid) {
        this.$zutil.notify("Pastikan data sudah terisi", false);
        this.loading = false;
        return false;
      }
      
      // Prepare data for submission
      this.form_fe.ternakan_list = this.data.ternakan_list.filter(item => item.pilih_betina);
      this.HantarFe();
    },

    

    HantarFe() {
      
      this.form_fe.baka_id = this.data.id;
      this.form_fe.premis_id = this.data.premis_id;
      this.form_fe.lkp_negeri_id = this.data.lkp_negeri_id;
      this.form_fe.lkp_ternakan_id = this.data.lkp_ternakan_id;
      this.$swal({
        title: 'Anda Pasti?',
        text: "Adakah anda pasti ingin menghantar permohonan FE ini?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, Hantar',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
            this.$zcomm.post(this.resourceurl + '/mohon-art', this.form_fe)
                  .then(res => {
                     this.$zutil.notify("Permohonan FE berjaya dihantar", true);
                      // this.$inertia.visit(this.$route('art.semakan.index'));
                      // this.$inertia.visit(this.$route('art.semakan.bse', res.id));
                     this.dialogPenilaianBetina.show = false;
                     this.getData();

                  })
                  .catch(error => {
                     this.$zutil.notify("Ralat ketika menghantar permohonan", false);
                     console.error(error);
                  })
                  .finally(() => {
                     this.loading = false;
                  });
           }
        });
    },




   send(hantar){
      this.form.hantar = hantar
      this.validateForm();
   },
   validateForm() {
      this.loading=true;
      let isValid = true;
      let jumlah_lulus = 0;
         if(this.data.id > 0){ 

            for (var i in this.data.ternakan_list) {
               if (this.data.ternakan_list[i].art_pdbf == null) {
                  this.$zutil.notify("Sila buat Permohonan BSE/FE dulu", false);
                  isValid = false;
                  break;
               }else{
                  if (this.data.ternakan_list[i].art_pdbf.tarikh_pdbf < this.data.ternakan_list[i].tarikh_batas) {
                     this.$zutil.notify("Tarikh akhir pemeriksaan BSE/FE telah lebih setahun, Sila buat Permohonan BSE/FE ", false);
                     isValid = false;
                     break;
                  }

                  if (this.data.ternakan_list[i].art_pdbf.art_status != 18) {
                     this.$zutil.notify("Pastikan data Permohonan BSE/FE sudah Selesai", false);
                     isValid = false;
                     break;
                  }

               }
            };
         }
      if (!isValid) {
        // this.$zutil.notify("Pastikan data sudah Permohonan BSE/FE sudah Selesai", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.onSuccess();
    },

     onSuccess(){
        if(this.form.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
           }).then((result) => {
              if (result.value) {

                this.form.ternakan_list = this.data.ternakan_list;
                this.$zcomm.post(this.resourceurl + '/update_baka', this.form)
                  .then(res => {
                     this.$zutil.notify("Berjaya disimpan", true);
                      this.$inertia.visit(this.$route('kelahiran.permohonan.baka_show', res.id));
                  })
                  
                  .finally(() => {
                     this.loading = false;
                  });
              }else{ }
         })
      }
   },

    // HantarArt(dt) {
    //   this.$swal({
    //           title: 'Anda Pasti?',
    //          text: "Adakah anda pasti ingin menghantar permohonan BSE/FE ini?",
    //           type: 'warning',
    //           showCancelButton: true,
    //           confirmButtonColor: '#3085d6',
    //           cancelButtonColor: '#d33',
    //           confirmButtonText: 'Ya',
    //           cancelButtonText: 'Tidak'
    //         }).then((result) => {
    //           if (result.value) {
    //             this.form.premis_id = this.data.premis_id;
    //             this.form.lkp_negeri_id = this.data.lkp_negeri_id;
    //             this.form.lkp_ternakan_id = this.data.lkp_ternakan_id;
    //             this.form.baka_butiran_id = dt.id;
    //             this.form.jantina = dt.jantina_id;
    //             this.form.ternakan_id = dt.ternakan_id;
    //             this.$zcomm.post(this.resourceurl + '/mohon-bse', this.form)
    //               .then(res => {
    //                  this.$zutil.notify("Permohonan BSE/FE berjaya dihantar", true);
    //                   // this.$inertia.visit(this.$route('art.semakan.index'));
    //                   // this.$inertia.visit(this.$route('art.semakan.bse', res.id));
    //                  this.getData();

    //               })
    //               .catch(error => {
    //                  this.$zutil.notify("Ralat ketika menghantar permohonan", false);
    //                  console.error(error);
    //               })
    //               .finally(() => {
    //                  this.loading = false;
    //               });
    //           }else{ }
    //      })
    // },

    tutup() {
      this.$inertia.visit(window.route('kelahiran.index'));
    },

     getPenilai(data){
         this.$zcomm.get(this.api_service + 'lookup/penilai', {lkp_negeri_id:data.lkp_negeri_id}).then(res => {
           this.penilai = res
         })
       },

    getAttahecment() {
      // Your existing attachment logic
    }
  },
  watch: {
    // Your existing watchers
  },
  mounted() {
    this.getData();
    this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.params.insemination == 1){
      this.activeTab = 5
    }
    if(this.params.vaksin == 1){
      this.activeTab = 4
    }
  },
}
</script>

<style>
ul.info-list {
  list-style-type: none;
}
ul.info-list li b {
  position: relative;
  display: inline-block;
  min-width: 160px;
  margin-right: 8px;
}
ul.info-list li b:after {
  content: ":";
  position: absolute;
  right: 0;
}
</style>